import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, mFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import moment from "moment-timezone";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);
class ShareOfVoiceForProductAttributesChart extends PureComponent {
    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        // console.log("helllllo", this.props);
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 10);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        } else {
            setTimeout(() => {
                this.ro.observe(this.props.widgetContainerRef?.current);
            }, 100);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getPieOptions = () => {
        let chartConfig = {};

        let self = this;
        let chartData = this.props.data.chartDataPie;
        let total = this.props.data.value;

        chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                verticalAlign: "middle",
                // text: `${mFormatter(total)}<br>Mentions`,
                text: "",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                y: 2,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        // format: "{point.name}: {point.percentage:.1f} %",
                        formatter: function () {
                            let key = this.key;
                            return key + " : " + mFormatter(this.y);
                        },
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                        padding: 0,
                    },
                    point: {
                        events: !this.props.insights__recommendation
                            ? {
                                  contextmenu: function (e) {
                                      e.preventDefault();
                                      self.props.addContextMenuListener(e.x, e.y, this);
                                  },
                              }
                            : {},
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    textTransform: "normal",
                    color: this.props.insights__recommendation ? "white" : "#333333",
                },
                alignColumns: false,
                // useHTML: true,
                maxHeight: 55,
                navigation: {
                    enabled: false,
                },
                itemHoverStyle: {
                    color: this.props.insights__recommendation ? "#84acd1" : "#000000",
                },
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    name: "Share of Voice by News Sources",
                    data: chartData,
                    //innerSize: "60%",
                },
            ],
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<b>${this.point.name} | ${this.point.percentage.toFixed(1) + "%"} | ${numberWithCommas(this.point.y)}/${numberWithCommas(
                        total,
                    )} </b>`;
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            plotOptions: {
                                pie: {
                                    dataLabels: {
                                        formatter: function () {
                                            let key = this.key.length > 12 ? this.key.substring(0, 12) + "..." : this.key;
                                            return key + " : " + mFormatter(this.y);
                                        },
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };

    getBarOptions = () => {
        let chartConfig = {};
        let chartData = this.props.data.chartDataBar;
        let total = this.props.data.value;
        let self = this;

        if (this.props.expandWidget) {
            if (this.props.data.maximizeBar[0]) {
                chartData = [...chartData, ...this.props.data.maximizeBar[0]];
            }
        } else {
            chartData = [...chartData, ...this.props.data.othersBar];
        }
        let heightOfScrollBar = chartData.length > 30 ? chartData.length * 20 : chartData.length;
        chartConfig = {
            chart: {
                type: "bar",
                className: "skiptranslate",
                //  backgroundColor: "transparent",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight: heightOfScrollBar,
                    opacity: 1,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            xAxis: {
                type: "category",
                lineWidth: 1,
                labels: {
                    useHTML: true,
                    // formatter: function () {
                    //     let value = this.value.length > 12 ? this.value.substring(0, 12) + "..." : this.value;
                    //     return value;
                    // },
                    style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "",
            },
            plotOptions: {
                series: {
                    stacking: "normal",
                    borderWidth: 0,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        inside: false,
                        formatter: function () {
                            return mFormatter(this.y);
                        },
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: !this.props.insights__recommendation
                            ? {
                                  contextmenu: function (e) {
                                      e.preventDefault();
                                      self.props.addContextMenuListener(e.x, e.y, this);
                                  },
                              }
                            : {},
                    },
                    events: {
                        legendItemClick: function () {
                            if (this.visible) {
                                this.setData([], false);
                            } else {
                                this.setData(chartData[this.index].data, false);
                            }
                        },
                    },
                },
            },

            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: this.props.expandWidget ? false : true,
                layout: this.props.expandWidget ? "horizontal" : "vertical",
                verticalAlign: this.props.expandWidget ? "bottom" : "middle",
                align: this.props.expandWidget ? "center" : "right",
                padding: this.props.expandWidget ? 0 : 3,
                itemMarginTop: this.props.expandWidget ? 0 : 3,
                itemMarginBottom: this.props.expandWidget ? 0 : 3,
                //  width: this.props.expandWidget ? "100%" : "20%",

                // : {
                //       enabled: this.props.showLegend,
                //       width: "20%",
                //       layout: "vertical",
                //       align: "right",
                //       padding: 3,
                //       itemMarginTop: 3,
                //       itemMarginBottom: 3,
                //       verticalAlign: "middle",
                //       itemStyle: {
                //           fontWeight: 500,
                //           textTransform: "normal",
                //       },

                //  enabled: this.props.showLegend,
                //   itemStyle: {
                //       fontWeight: 500,
                //       fontFamily: "'Roboto', sans-serif",
                //       textTransform: "normal",
                //   },
                //   alignColumns: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: chartData,
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<b>${this.key} | ${((this.y * 100) / total).toFixed(1) + "%"} | ${numberWithCommas(this.y)}/${numberWithCommas(total)} </b>`;
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            xAxis: {
                                labels: {
                                    formatter: function () {
                                        let value = this.value.length > 12 ? this.value.substring(0, 12) + "..." : this.value;
                                        return value;
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };

    getLineOptions = () => {
        let data = this.props.data.chartDataLine;
        let comparisionData = this.props.comparisionData && this.props.comparisionData.chartDataLine;
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;
        data &&
            data.map((d, i) => {
                if (d.color && d.color.length == 0) d.color = "#000000";
            });
        if (comparisionData) {
            comparisionData.map((d, i) => {
                d.linkedTo = ":previous";
                if (d.color && d.color.length == 0) d.color = "#00000055";
                else if (d.color && d.color.length <= 7) d.color = d.color + "55";
            });
        }

        // let self = this;
        // let tz = JSON.parse(localStorage.company).user_timezone_name;
        // let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let plotComaprisiondata;
        let arrayCombined = [];

        let plotComaprisiondataCondition = comparisionData && comparisionData[0].data.length >= data[0].data.length;

        if (plotComaprisiondataCondition && data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(data));

            comparisionData.forEach((ele, index) => {
                ele.data.forEach((element, ind) => {
                    if (plotComaprisiondata[index].data[ind]) {
                        plotComaprisiondata[index].data[ind].originalX = plotComaprisiondata[index].data[ind].x;
                        plotComaprisiondata[index].data[ind].x = element.x;
                    }
                });
            });
        } else {
            if (comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(comparisionData));

                this.props.data &&
                    data.forEach((ele, index) => {
                        ele.data.forEach((element, ind) => {
                            if (plotComaprisiondata[index].data[ind]) {
                                plotComaprisiondata[index].data[ind].originalX = plotComaprisiondata[index].data[ind].x;
                                plotComaprisiondata[index].data[ind].x = element.x;
                            }
                        });
                    });
            }
        }

        if (comparisionData) {
            data = data.sort((a, b) => {
                if (a.value > b.value) return -1;
                else return 1;
            });
            comparisionData = comparisionData.sort((a, b) => {
                if (a.value > b.value) return -1;
                else return 1;
            });

            plotComaprisiondata = plotComaprisiondata.sort((a, b) => {
                if (a.value > b.value) return -1;
                else return 1;
            });

            plotComaprisiondataCondition
                ? data.forEach((element, ind) => {
                      let comparisionIndex = comparisionData.find((ele) => ele.subtopicId == element.subtopicId);

                      arrayCombined.push(plotComaprisiondata[ind]);
                      if (comparisionIndex) arrayCombined.push(comparisionIndex);
                  })
                : comparisionData.forEach((element, ind) => {
                      let plotComparisionIndex = plotComaprisiondata.find((ele) => ele.subtopicId == element.subtopicId);

                      arrayCombined.push(data[ind]);
                      if (plotComparisionIndex) arrayCombined.push(plotComparisionIndex);
                  });
        }

        // arrayCombined.length > 3 &&
        arrayCombined.map((d, i) => {
            if (i > 3) {
                d.visible = false;
            }
        });

        let serObj = this.props.comparisionData ? arrayCombined : data;

        // let normalMinValue;
        // let normalMaxValue;
        // let serObj;
        // let durationDiff;
        // var arrayCombined = [];
        // let normalDurationDiff;
        // let comparisionMaxValue;

        // if (this.props.comparisionData && this.props.comparisionData.chartDataLine) {
        //     comparisionData.map((d, i) => {
        //         d.linkedTo = ":previous";
        //         d.xAxis = 1;
        //         d.color = d.color + "55";
        //         if (d.name === "Others") {
        //             d.visible = false;
        //         }
        //     });

        //     data.map((d, i) => {
        //         if (d.name === "Others") {
        //             d.visible = false;
        //         }
        //     });

        //     if (this.props.comparisionData) {
        //         data = data.sort((a, b) => {
        //             if (a.name > b.name) return 1;
        //             else return -1;
        //         });
        //         comparisionData = comparisionData.sort((a, b) => {
        //             if (a.name > b.name) return 1;
        //             else return -1;
        //         });

        //         data.forEach((element, ind) => {
        //             arrayCombined.push(data[ind]);
        //             arrayCombined.push(comparisionData[ind]);
        //         });
        //         // arrayCombined = $.map(data, function (v, i) {
        //         //     return [v, comparisionData[i]];
        //         // });
        //     }

        //     normalMinValue = data[0].data[0].x;
        //     normalMaxValue = data[0].data[data[0].data.length - 1].x;

        //     normalMinValue = moment(normalMinValue).tz(tz);
        //     normalMaxValue = moment(normalMaxValue).tz(tz);
        //     normalDurationDiff = moment(normalMaxValue).diff(moment(normalMinValue), "d");

        //     let comparisionMinValue = this.props.comparisionData && comparisionData[0].data[0].x;
        //     comparisionMaxValue = this.props.comparisionData && comparisionData[0].data[comparisionData[0].data.length - 1].x;

        //     comparisionMinValue = moment(comparisionMinValue).tz(tz);
        //     comparisionMaxValue = moment(comparisionMaxValue).tz(tz);

        //     durationDiff = moment(comparisionMaxValue).diff(moment(comparisionMinValue), "d");
        // }
        // serObj = this.props.comparisionData ? arrayCombined : data;
        const chartOptions = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },

            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    labels: {
                        format: "{value:%b %e}",
                    },
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                outside: true,
                crosshairs: true,
                useHTML: true,
                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("55");
                            let secondColorPoint = this.points[0]?.color.endsWith("55");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }
                            temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }
                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point.series.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
                backgroundColor: "#fff",
                // style: {
                //     zIndex: 999999,
                // },
                borderRadius: 6,
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                spline: {
                    point: {
                        events: !this.props.insights__recommendation
                            ? {
                                  contextmenu: function (e) {
                                      e.preventDefault();
                                      self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                                  },
                              }
                            : {},
                    },
                },

                series: {
                    marker: {
                        radius: 4,
                        enabled: true,
                        symbol: "circle",
                    },
                },
            },

            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartOptions;
    };

    render() {
        return (
            <>
                {this.props.currentChartType === "pie" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getPieOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
                    />
                )}
                {this.props.currentChartType === "bar" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getBarOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
                    />
                )}
                {this.props.currentChartType === "line" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getLineOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
                    />
                )}
            </>
        );
    }
}

export default ShareOfVoiceForProductAttributesChart;
